<template>
  <div class="dataWatch">
    <div style="" class="titleDiv">
      <div class="fullScreenLogo"></div>
      <img
        class="fullScreenTitle"
        :src="require('../../../assets/dataWatchImg/en/dashboard_top_title_en.png')"
        height="48px"
        style="position: relative; margin-top: 10px;  margin-left: calc(50% - 465px)"
      />
      <!--      style="justify-content: center;margin:8px 100px 8px auto;"-->
      <div class="nowDateDIV">{{ newDate }}</div>
      <div
        class="changeBtn"
        @click="switchFullSceen"
        :title="btnStyle ? $t('FullScreen.exit') : $t('FullScreen.viewFullScreen')"
      >
        <div :class="{ enlarge: btnStyle, narrow: !btnStyle }"></div>
      </div>
      <div v-if="!btnStyle" class="exitBtn" @click="gotoStatistic" :title="$t('FullScreen.back')">
        <div class="gobackIcon"></div>
      </div>
    </div>
    <div class="todayDataList">
      <div class="todayDataItem1">
        <div class="leftContent">
          <div class="leftTitle"></div>
          <div class="leftTodayData">
            <CountFlop :val="todayAddUserData.todayNum" />
            <!--            {{ getNumberStr(222890) }}-->
          </div>
          <div class="leftTodayDataRate">
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.weeklyRate') }}
              <span v-if="todayAddUserData.weeklyRate > 0" class="upRate">
                {{ todayAddUserData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayAddUserData.weeklyRate === 0" class="keepRate">
                {{ todayAddUserData.weeklyRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayAddUserData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
            <!--            <span class="leftTodayDataRateSplit">|</span>-->
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.dayRate') }}
              <span v-if="todayAddUserData.dayRate > 0" class="upRate">
                {{ todayAddUserData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayAddUserData.dayRate === 0" class="keepRate">
                {{ todayAddUserData.dayRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayAddUserData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
          </div>
          <div class="totalData">
            <span class="totalDataTitle">
              {{ $t('FullScreen.totalUser') }}
            </span>
            <span class="totalDataContent">
              {{ getNumberStr(todayAddUserData.totalNum) }}
            </span>
          </div>
        </div>
        <div class="rightImg"></div>
      </div>
      <div class="todayDataItem2">
        <div class="leftContent">
          <div class="leftTitle"></div>
          <div class="leftTodayData">
            <!--            {{ getNumberStr(222890) }}-->
            <CountFlop :val="todayInstallDeviceData.todayNum" />
          </div>
          <div class="leftTodayDataRate">
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.weeklyRate') }}
              <span v-if="todayInstallDeviceData.weeklyRate > 0" class="upRate">
                {{ todayInstallDeviceData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayInstallDeviceData.weeklyRate === 0" class="keepRate">
                {{ todayInstallDeviceData.weeklyRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayInstallDeviceData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
            <!--            <span class="leftTodayDataRateSplit">|</span>-->
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.dayRate') }}
              <span v-if="todayInstallDeviceData.dayRate > 0" class="upRate">
                {{ todayInstallDeviceData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayInstallDeviceData.dayRate === 0" class="keepRate">
                {{ todayInstallDeviceData.dayRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayInstallDeviceData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
          </div>
          <div class="totalData">
            <span class="totalDataTitle">
              {{ $t('FullScreen.totalInstall') }}
            </span>
            <span class="totalDataContent">
              {{ getNumberStr(todayInstallDeviceData.totalNum) }}
            </span>
          </div>
        </div>
        <div class="rightImg"></div>
      </div>
      <div class="todayDataItem3">
        <div class="leftContent">
          <div class="leftTitle"></div>
          <div class="leftTodayData">
            <!--            {{ getNumberStr(222890) }}-->
            <CountFlop :val="todayDownloadRecipeData.todayNum" />
          </div>
          <div class="leftTodayDataRate">
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.weeklyRate') }}
              <span v-if="todayDownloadRecipeData.weeklyRate > 0" class="upRate">
                {{ todayDownloadRecipeData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayDownloadRecipeData.weeklyRate === 0" class="keepRate">
                {{ todayDownloadRecipeData.weeklyRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayDownloadRecipeData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
            <!--            <span class="leftTodayDataRateSplit">|</span>-->
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.dayRate') }}
              <span v-if="todayDownloadRecipeData.dayRate > 0" class="upRate">
                {{ todayDownloadRecipeData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayDownloadRecipeData.dayRate === 0" class="keepRate">
                {{ todayDownloadRecipeData.dayRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayDownloadRecipeData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
          </div>
          <div class="totalData">
            <span class="totalDataTitle">
              {{ $t('FullScreen.totalDownload') }}
            </span>
            <span class="totalDataContent">
              {{ getNumberStr(todayDownloadRecipeData.totalNum) }}
            </span>
          </div>
        </div>
        <div class="rightImg"></div>
      </div>
      <div class="todayDataItem4">
        <div class="leftContent">
          <div class="leftTitle"></div>
          <div class="leftTodayData">
            <!--            {{ getNumberStr(222890) }}-->
            <CountFlop :val="todayCollectRecipeData.todayNum" />
          </div>
          <div class="leftTodayDataRate">
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.weeklyRate') }}
              <span v-if="todayCollectRecipeData.weeklyRate > 0" class="upRate">
                {{ todayCollectRecipeData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayCollectRecipeData.weeklyRate === 0" class="keepRate">
                {{ todayCollectRecipeData.weeklyRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayCollectRecipeData.weeklyRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
            <!--            <span class="leftTodayDataRateSplit">|</span>-->
            <div class="leftTodayDataRateWeek">
              {{ $t('FullScreen.dayRate') }}
              <span v-if="todayCollectRecipeData.dayRate > 0" class="upRate">
                {{ todayCollectRecipeData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                  alt="up"
                />
              </span>
              <span v-else-if="todayCollectRecipeData.dayRate === 0" class="keepRate">
                {{ todayCollectRecipeData.dayRate }}%
              </span>
              <span v-else class="downRate">
                {{ todayCollectRecipeData.dayRate | formatNumWithComma }}%
                <img
                  :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                  alt="down"
                />
              </span>
            </div>
          </div>
          <div class="totalData">
            <span class="totalDataTitle">
              {{ $t('FullScreen.totalCollect') }}
            </span>
            <span class="totalDataContent">
              {{ getNumberStr(todayCollectRecipeData.totalNum) }}
            </span>
          </div>
        </div>
        <div class="rightImg"></div>
      </div>
    </div>
    <div class="bottomDiv">
      <div class="leftRecipe">
        <div class="leftRecipeTitle1">
          <img
            :src="
              require('../../../assets/dataWatchImg/en/dashboard_popular_cookbook_title_en.png')
            "
            style="height: 48px"
          />
        </div>
        <div class="leftRecipeDiv">
          <div class="leftRecipeDownloadTitle"></div>
          <div class="recipeDownloadList">
            <div class="recipeDownloadItemLeft">
              <div
                :class="i < 3 ? 'recipeDownloadItem' + i : 'recipeDownloadItem'"
                v-for="(itemLeft, i) in recipeDownLoadListLeft"
                :key="i"
              >
                <div class="indexDiv">
                  {{ i + 1 }}
                </div>
                <div class="barDiv">
                  <div class="itemDesc">
                    <div class="itemDescName">{{ itemLeft.name }}</div>
                    <div class="itemDescValue">
                      {{ getNumberStr(itemLeft.value) }}
                    </div>
                  </div>
                  <el-progress
                    :show-text="false"
                    :percentage="((itemLeft.value * 100) / downLoadTotal).toFixed(2)"
                    class="progressDiv"
                    :text-color="'#4DBBFF'"
                    :define-back-color="'rgba(204,216,255,0.2)'"
                  ></el-progress>
                </div>
              </div>
            </div>
            <div class="recipeDownloadItemRight">
              <div
                class="recipeDownloadItem"
                v-for="(itemRight, i) in recipeDownLoadListRight"
                :key="i + 6"
              >
                <div class="indexDiv">
                  {{ i + 6 }}
                </div>
                <div class="barDiv">
                  <div class="itemDesc">
                    <div class="itemDescName">{{ itemRight.name }}</div>
                    <div class="itemDescValue">{{ getNumberStr(itemRight.value) }}</div>
                  </div>
                  <el-progress
                    :show-text="false"
                    :percentage="((itemRight.value * 100) / downLoadTotal).toFixed(2)"
                    class="progressDiv"
                    :text-color="'#4DBBFF'"
                    :define-back-color="'rgba(204,216,255,0.2)'"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="leftRecipeBottom">
            <div class="downLoadType">
              <div class="leftRecipeTypeDownloadTitle"></div>
              <div class="leftRecipeTypeDownloadImg" id="recipeTypeDownload"></div>
            </div>
            <div class="searchKeyDiv">
              <div class="leftRecipeTypeDownloadTitle"></div>
              <div class="searchKeyContent" id="searchKeyImg"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightRecipe">
        <div>
          <div class="rightRecipeTitle1">
            <img
              :src="require('../../../assets/dataWatchImg/en/dashboard_popular_model_title_en.png')"
              height="34px"
              alt=""
            />
          </div>
          <div class="rightRecipeHeatModel">
            <el-row class="rightRecipeHeatModelRowTitle">
              <el-col :span="2">
                {{ $t('FullScreen.number') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.model') }}
              </el-col>
              <el-col :span="8">
                {{ $t('FullScreen.installNum') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.weekGrowRate') }}
              </el-col>
            </el-row>
            <el-row
              :class="i < 3 ? 'rightRecipeHeatModelRow' + i : 'rightRecipeHeatModelRow'"
              v-for="(itemModel, i) in popularModelInWeekList"
              :key="i"
            >
              <el-col :span="2" class="indexCol">
                <div>{{ i + 1 }}</div>
              </el-col>
              <el-col :span="22">
                <div class="rightRecipeHeatModelIndexOther">
                  <div style="width: 56%">
                    {{ itemModel.name }}
                  </div>
                  <div style="width: 28%; fontFamily:Barlow-SemiBold, Barlow;">
                    {{ getNumberStr(itemModel.value) }}
                  </div>
                  <div style="width: 16%" v-if="itemModel.growRate > 0" class="upRate">
                    {{ itemModel.growRate }}%
                    <img
                      :src="require('../../../assets/dataWatchImg/dashboard_rise_sjx.svg')"
                      alt="up"
                    />
                  </div>
                  <div style="width: 16%" v-else-if="itemModel.growRate === 0" class="keepRate">
                    {{ itemModel.growRate }}%
                  </div>
                  <div style="width: 16%" v-else class="downRate">
                    {{ itemModel.growRate }}%
                    <img
                      :src="require('../../../assets/dataWatchImg/dashboard_reduce_sjx.svg')"
                      alt="up"
                    />
                  </div>
                </div>
              </el-col>
              <!--              <div class='rightRecipeHeatModelIndexOther'>-->
              <!--                <el-col :span="10">-->
              <!--                  {{itemModel.name}}-->
              <!--                </el-col>-->
              <!--                <el-col :span="6">-->
              <!--                  {{itemModel.value}}-->
              <!--                </el-col>-->
              <!--                <el-col :span="3">-->
              <!--                  {{itemModel.growRate}}%-->
              <!--                </el-col>-->
              <!--              </div>-->
            </el-row>
          </div>
        </div>
        <div style="margin-top: 16px">
          <div class="rightRecipeTitle1">
            <img
              :src="
                require('../../../assets/dataWatchImg/en/dashboard_publish_cookbook_title_en.png')
              "
              height="34px"
              alt=""
            />
          </div>
          <div class="rightLastPublishRecipe">
            <el-row class="rightRecipeHeatModelRowTitle">
              <el-col :span="2">
                {{ $t('FullScreen.number') }}
              </el-col>
              <el-col :span="8">
                {{ $t('FullScreen.recipeName') }}
              </el-col>
              <el-col :span="6">
                {{ $t('FullScreen.recipeType') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.publishTime') }}
              </el-col>
            </el-row>
            <el-row
              :class="i % 2 === 0 ? 'rightLastPublishRecipeRow0' : 'rightLastPublishRecipeRow1'"
              v-for="(itemRecipe, i) in lastPublishRecipeList"
              :key="i"
            >
              <el-col :span="2" style="padding-left: 8px;">
                <div>{{ i + 1 }}</div>
              </el-col>
              <el-col :span="8">
                <!--                {{ itemRecipe.name }}-->
                <el-tooltip effect="dark" :content="itemRecipe.name" placement="top">
                  <div
                    style="max-width: 100px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >
                    {{ itemRecipe.name || '--' }}
                  </div>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                {{ itemRecipe.type || '--' }}
              </el-col>
              <el-col :span="7" style="fontFamily:Barlow-SemiBold, Barlow;">
                {{ itemRecipe.publishTime | formatTime }}
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="margin-top: 16px">
          <div class="rightRecipeTitleFault">
            <img
              :src="require('../../../assets/dataWatchImg/en/dashboard_fault_title_en.png')"
              height="34px"
              alt=""
            />
          </div>
          <div class="rightRecipeFault">
            <el-row class="rightRecipeFaultRowTitle">
              <el-col :span="2">
                {{ $t('FullScreen.number') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.errorReason') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.model') }}
              </el-col>
              <el-col :span="7">
                {{ $t('FullScreen.reportTime') }}
              </el-col>
            </el-row>
            <el-row
              :class="i % 2 === 0 ? 'rightRecipeFaultRow0' : 'rightRecipeFaultRow1'"
              v-for="(itemFault, i) in recipeFaultList"
              :key="i"
            >
              <el-col :span="2" style="padding-left: 8px;">
                <div>{{ i + 1 }}</div>
              </el-col>
              <el-col :span="7">
                <el-tooltip effect="dark" :content="itemFault.name" placement="top">
                  <div
                    style="max-width: 100px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >
                    {{ itemFault.name || '--' }}
                  </div>
                </el-tooltip>
              </el-col>
              <el-col :span="7">
                {{ itemFault.model || '--' }}
              </el-col>
              <el-col :span="7" style="fontFamily:Barlow-SemiBold, Barlow;">
                {{ itemFault.reportTime | formatTime }}
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeTimeType2, getNumberStr, formatTime, formatNumWithComma } from '@/utils/utils'
import animate from 'animate.css'
import CountFlop from './component/CountFlop.vue'
const echarts = require('echarts')
import 'echarts-wordcloud'
export default {
  name: 'EnIndex',
  components: {
    CountFlop
  },
  data() {
    return {
      btnStyle: false,
      newDate: null, // 当前日期时间
      DateTimer: null, // 当前日期时间定时器
      TodayDataTimer: null, // 今日数据定时器
      //今日注册用户
      todayAddUserData: {
        weeklyRate: 0,
        dayRate: 0,
        totalNum: 0,
        todayNum: 0
      },
      //今日安装设备
      todayInstallDeviceData: {
        weeklyRate: 0,
        dayRate: 0,
        totalNum: 0,
        todayNum: 0
      },
      //今日下载菜谱次数
      todayDownloadRecipeData: {
        weeklyRate: 0,
        dayRate: 0,
        totalNum: 0,
        todayNum: 0
      },
      //今日收藏菜谱数
      todayCollectRecipeData: {
        weeklyRate: 0,
        dayRate: 0,
        totalNum: 0,
        todayNum: 0
      },
      //菜谱下载
      recipeDownLoadList: [],
      //菜谱分类下载
      recipeTypeDownList: [],
      //搜索关键词
      recipeSearchKeyList: [],
      recipeTypeDownFlag: false,
      //本周热门型号
      popularModelInWeekList: [],
      //最新发布菜谱
      lastPublishRecipeList: [],
      //最新故障情况
      recipeFaultList: [],
      colorList: [
        '#2046C7',
        '#88C36C',
        '#FAC858',
        '#EF6767',
        '#9661BC',
        '#70C1E1',
        '#3CAB77',
        '#FC8452',
        '#5377B7',
        '#F08BB4'
      ],
      maskImage: require('../../../assets/device.png'),

      //语言切换时的图片文件
      imgFile: {}
    }
  },
  created() {
    //今日注册用户
    this.todayAddUser()
    //今日安装设备
    this.todayInstallDevice()
    //今日下载菜谱次数
    this.todayDownloadRecipe()
    //今日收藏菜谱次数
    this.todayCollectRecipe()
    this.btnStyle = false
    // 当前日期时间
    this.newDate = changeTimeType2(new Date().toString())
    this.DateTimer = setInterval(() => {
      this.newDate = changeTimeType2(new Date().toString())
    }, 1000)

    this.TodayDataTimer = setInterval(() => {
      //今日注册用户
      this.todayAddUser()
      //今日安装设备
      this.todayInstallDevice()
      //今日下载菜谱次数
      this.todayDownloadRecipe()
      //今日收藏菜谱次数
      this.todayCollectRecipe()
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.DateTimer)
    clearInterval(this.TodayDataTimer)
  },
  mounted() {
    //本周热门菜谱
    this.popularRecipeInWeekGet()
    //菜谱分类下载
    this.recipeTypeDownLoadGET()
    //搜索关键词
    this.initSearchKey()
    //本周热门型号
    this.popularModelInWeekGet()
    //最新发布菜谱
    this.publishRecipeGet()
    //最新故障情况
    this.recipeFaultGet()
  },
  computed: {
    recipeDownLoadListLeft() {
      if (this.recipeDownLoadList.length > 4) {
        return this.recipeDownLoadList.slice(0, 5)
      } else {
        return this.recipeDownLoadList
      }
    },
    recipeDownLoadListRight() {
      if (this.recipeDownLoadList.length > 5) {
        return this.recipeDownLoadList.slice(5)
      } else {
        return []
      }
    },
    downLoadTotal() {
      let total = 0
      this.recipeDownLoadList.forEach((item) => {
        total += item.value
      })
      return total
    }
  },
  filters: {
    formatTime(val) {
      return formatTime(val)
    },
    formatNumWithComma
  },
  methods: {
    changeTimeType2,
    getNumberStr,
    //今日注册用户
    todayAddUser() {
      this.$ajax.get(this.$api.statistics.fullScreen_user).then((res) => {
        let obj = {}
        obj = {
          weeklyRate: res.data.weeklyRate,
          dayRate: res.data.dayRate,
          totalNum: res.data.totalNum,
          todayNum: res.data.todayNum
        }
        this.todayAddUserData = obj
      })
    },
    //今日安装设备
    todayInstallDevice() {
      this.$ajax.get(this.$api.statistics.installDevice_today_num).then((res) => {
        let obj = {}
        obj = {
          weeklyRate: res.data.weeklyRate,
          dayRate: res.data.dayRate,
          totalNum: res.data.totalNum,
          todayNum: res.data.todayNum
        }
        this.todayInstallDeviceData = obj
      })
    },
    //今日下载菜谱次数
    todayDownloadRecipe() {
      this.$ajax.get(this.$api.statistics.download_recipe_today_num).then((res) => {
        let obj = {}
        obj = {
          weeklyRate: res.data.weeklyRate,
          dayRate: res.data.dayRate,
          totalNum: res.data.totalNum,
          todayNum: res.data.todayNum
        }
        this.todayDownloadRecipeData = obj
      })
    },
    //今日收藏菜谱次数
    todayCollectRecipe() {
      this.$ajax.get(this.$api.statistics.collect_recipe_today_num).then((res) => {
        let obj = {}
        obj = {
          weeklyRate: res.data.weeklyRate,
          dayRate: res.data.dayRate,
          totalNum: res.data.totalNum,
          todayNum: res.data.todayNum
        }
        this.todayCollectRecipeData = obj
      })
    },
    //本周热门菜谱
    popularRecipeInWeekGet() {
      this.$ajax.get(this.$api.statistics.popularRecipeInWeek).then((res) => {
        this.recipeDownLoadList = res.data
      })
    },
    //菜谱分类下载
    recipeTypeDownLoadGET() {
      this.$ajax.get(this.$api.statistics.recipeType_download).then((res) => {
        let total = 0
        res.data.forEach((item) => {
          total += item.value
        })
        this.recipeTypeDownFlag = true
        this.recipeTypeDownList = res.data
        this.$nextTick(() => {
          // let userAreaData = echarts.init(this.$refs.userAreaData)
          let myChartContainer = document.getElementById('recipeTypeDownload')
          myChartContainer.style.width = 622 + 'px'
          let recipeSuitModel = echarts.init(myChartContainer)
          // 图表自适应
          window.addEventListener('resize', () => {
            recipeSuitModel.resize()
          })
          let option = {
            title: {
              zlevel: 2, // 控制圆环图中间的字的层级
              text: `${total}`, // 主标题
              top: '38%', // 控制位置
              left: '23.5%', // 控制位置
              textStyle: {
                // 主标题样式
                color: '#ffffff',
                fontWeight: '600',
                fontSize: 32,
                fontFamily: 'Barlow-SemiBold, Barlow'
              },
              subtext: this.$t('FullScreen.RecipeDownloadTotal'), // 副标题
              subtextStyle: {
                // 副标题样式
                color: 'rgba(255,255,255,0.6)',
                fontSize: 12,
                fontWeight: '400'
              },
              textAlign: 'center' // 让文字居中
            },
            color: this.colorList,

            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              top: '20%', // 调整位置
              right: '0%', // 距离右侧位置
              icon: 'circle', // 修改小图标为圆形
              // type: 'scroll',
              // pageIconColor: '#2046C7', //翻页下一页的三角按钮颜色
              // pageIconInactiveColor: '#aaa', //翻页（即翻页到头时）
              // pageIconSize: 14, //翻页按钮大小
              // pageButtonItemGap: 6,//翻页按钮的两个之间的间距

              textStyle: {
                // 文字的样式
                fontSize: 14, // 可控制每个legend项的间距
                color: '#828282',

                rich: {
                  // 通过富文本rich给每个项设置样式，下面的oneone、twotwo、threethree可以理解为"每一列"的样式
                  oneone: {
                    // 设置文字、数学、英语这一列的样式
                    width: 75,
                    color: '#FFFFFF',
                    fontSize: 12,
                    fontWeight: '600'
                  },
                  twotwo: {
                    // 设置10分、20分、30分这一列的样式
                    width: 25,
                    color: 'rgba(255,255,255,0.6)',
                    fontSize: 12,
                    fontWeight: '400'
                  },
                  threethree: {
                    // 设置百分比这一列的样式
                    width: 30,
                    color: '#00C4FF',
                    fontSize: 12,
                    fontWeight: '600',
                    align: 'right'
                  }
                }
              },
              formatter: (name) => {
                // formatter格式化函数动态呈现数据
                let total = 0 // 用于计算总数
                let target // 遍历拿到数据
                for (let i = 0; i < res.data.length; i++) {
                  total += res.data[i].value
                  if (res.data[i].name === name) {
                    target = res.data[i].value
                  }
                }
                let v = ((target / total) * 100).toFixed(2)
                return `{oneone|${name}}  {twotwo|${v}%}   {threethree|${target}}`
                //     富文本第一列样式应用    富文本第二列样式应用      富文本第三列样式应用
              },
              itemWidth: 8, //图例宽度
              itemHeight: 8 //图例高度
            },
            series: [
              {
                name: this.$t('FullScreen.proportion'),
                type: 'pie',
                radius: ['55%', '70%'],
                center: ['24.3%', '50%'],
                avoidLabelOverlap: false,
                data: res.data,
                itemStyle: {
                  borderWidth: 4, //设置border的宽度有多大
                  borderColor: '#132560'
                },
                label: {
                  position: 'center',
                  show: false,
                  formatter: () => {
                    return `${100}` + '菜谱总数' + '\n'
                  },
                  color: '#1E7CE8',
                  lineHeight: 16,
                  fontSize: 12
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                }
              }
            ]
          }
          option && recipeSuitModel.setOption(option)
        })
      })
    },
    //搜索关键词
    initSearchKey() {
      this.$ajax.get(this.$api.statistics.search_keyword).then((res) => {
        this.recipeSearchKeyList = res.data
        this.$nextTick(() => {
          const chart = echarts.init(document.getElementById('searchKeyImg'))
          let colorList = [
            '#2046C7',
            '#88C36C',
            '#FAC858',
            '#EF6767',
            '#9661BC',
            '#70C1E1',
            '#3CAB77',
            '#FC8452',
            '#5377B7',
            '#F08BB4',
            '#F05BB6'
          ]
          chart.setOption({
            series: [
              {
                type: 'wordCloud',
                // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
                shape: 'circle',
                // 这个功能还没用过
                keepAspect: false,
                // 这个是可以自定义背景图片的，词云会按照图片的形状排布，所以有形状限制的时候，最好用背景图来实现，而且，这个背景图一定要放base64的，不然词云画不出来
                //  maskImage: this.maskImage,
                // 下面就是位置的配置
                left: 'center',
                top: 'center',
                width: '70%',
                height: '80%',
                right: null,
                bottom: null,
                // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
                sizeRange: [12, 60],
                // 每个词旋转的角度范围和旋转的步进
                rotationRange: [0, 0],
                rotationStep: 45,
                // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
                gridSize: 16,
                // 允许词太大的时候，超出画布的范围
                drawOutOfBound: false,
                // 布局的时候是否有动画
                layoutAnimation: true,
                // 这是全局的文字样式，相对应的还可以对每个词设置字体样式

                textStyle: {
                  fontFamily: 'sans-serif',
                  fontWeight: 'bold',
                  // 颜色可以用一个函数来返回字符串，这里是随机色
                  // color: function (i) {
                  //   // Random color
                  //   console.log(i)
                  //
                  // }
                  color: function() {
                    console.log()
                    let index = Math.floor(Math.random() * colorList.length)
                    return colorList[index]
                  }

                  // color: function() {
                  //   let index = Math.floor(Math.random() * this.colorList.length)
                  //   console.log('index',index)
                  //   return this.colorList[index]
                  // }
                },
                emphasis: {
                  focus: 'self',
                  textStyle: {
                    textShadowBlur: 10,
                    textShadowColor: '#333'
                  }
                },

                // 数据必须是一个数组，数组是对象，对象必须有name和value属性
                data: res.data
              }
            ]
          })
        })
      })
    },
    //本周热门型号
    popularModelInWeekGet() {
      this.$ajax.get(this.$api.statistics.popularModelInWeek).then((res) => {
        this.popularModelInWeekList = res.data
      })
    },
    //最新发布菜谱
    publishRecipeGet() {
      this.$ajax.get(this.$api.statistics.lastPublishRecipe).then((res) => {
        this.lastPublishRecipeList = res.data
      })
    },
    //最新故障情况
    recipeFaultGet() {
      this.$ajax.get(this.$api.statistics.lastFaultDevice).then((res) => {
        this.recipeFaultList = res.data
      })
    },
    //切换全屏
    switchFullSceen() {
      const flag = JSON.parse(JSON.stringify(this.btnStyle))
      let docElm = document.documentElement
      if (flag) {
        //处于大屏状态,点击退出全屏
        // W3C
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          // FireFox
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          // Chrome等
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          // IE11
          document.msExitFullscreen()
        }
        this.btnStyle = !flag
      } else {
        // 进入全屏
        // W3C
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          // FireFox
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          // Chrome等
          docElm.webkitRequestFullScreen()
        } else if (docElm.msRequestFullscreen) {
          // IE11
          docElm.msRequestFullscreen()
        }
        this.btnStyle = !flag
      }
    },
    //退出,返回到统计页面
    gotoStatistic() {
      const { href } = this.$router.resolve({
        name: 'Statistic'
      })
      window.open(href, '_self')
    }
  }
}
</script>

<style lang="scss" scoped>
.dataWatch {
  //position: relative;
  width: 100%;
  overflow: auto;
  //height: 800px;
  min-width: 1920px;
  //overflow-x: scroll;
  //overflow-y: scroll;
  background-image: url('../../../assets/dataWatchImg/dashboard_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .fullScreenLogo {
    //position: absolute;
    //top: 20px;
    //left: 24px;
    margin: 20px 0 auto 24px;
    width: 185px;
    height: 32px;
    background-image: url('../../../assets/dataWatchImg/dashboard_logo.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .fullScreenTitle {
    height: 36px;
    position: relative;
    margin-top: 10px;
    margin-left: calc(50% - 436px);
  }
  .titleDiv {
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    //max-width: 1324px;
    width: 100%;
    height: 90px;
    // line-height: 60px;
    //font-size: 32px;
    // text-align: center;
    background-image: url('../../../assets/dataWatchImg/en/dashboard_top_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .nowDateDIV {
    //position: absolute;
    //top: 22px;
    //right: 100px;
    text-align: right;
    margin: 22px 80px auto auto;
    width: 200px;
    height: 16px;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
  }
  .changeBtn {
    //position: absolute;
    //top: 22px;
    //right: 20px;
    margin: 10px 20px auto 32px;
    //width: 16px;
    //height: 16px;

    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background: rgba(0, 60, 255, 0.4);
    border: 1px solid #5c6a99;
    display: flex;
    text-align: center;
    align-items: center;
    .enlarge {
      position: relative;
      //margin-top:8px;
      margin-left: 7px;
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/dataWatchImg/dashboard_exit_full_screen.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .narrow {
      position: relative;
      //margin-top:8px;
      margin-left: 7px;
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/dataWatchImg/dashboard_full_screen.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      background: rgba(0, 60, 255, 0.6);
    }
    &:active {
      background: #3d4766;
    }
  }
  .exitBtn {
    margin: 10px 20px auto 0px;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background: rgba(0, 60, 255, 0.4);
    border: 1px solid #5c6a99;
    display: flex;
    text-align: center;
    align-items: center;
    .gobackIcon {
      position: relative;
      //margin-top:8px;
      margin-left: 7px;
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/dataWatchImg/dashboard_exit.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      background: rgba(0, 60, 255, 0.6);
    }
    &:active {
      background: #3d4766;
    }
  }
  .todayDataList {
    display: flex;
    margin: 24px;
    .todayDataItem1 {
      display: flex;
      width: calc(25% - 24px);
      min-width: 450px;
      height: 174px;
      //margin-bottom: 24px;
      margin-right: 24px;
      // text-align: center;
      background-image: url('../../../assets/dataWatchImg/dashboard_top_card_bg_01.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .leftContent {
        z-index: 10;
        width: calc(100% - 174px);
        height: 174px;
        .leftTitle {
          width: 450px;
          height: 40px;
          background-image: url('../../../assets/dataWatchImg/en/dashboard_top_card_title_en_01.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .leftTodayData {
          margin-left: 34px;
          margin-bottom: -1px;
          font-size: 48px;
          font-family: Barlow-SemiBold, Barlow;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        .leftTodayDataRate {
          margin-left: 34px;
          color: rgba(255, 255, 255, 0.6);
          .leftTodayDataRateSplit {
            margin: 0 8px;
          }
          .leftTodayDataRateWeek {
            .upRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ff4d79;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .downRate {
              margin-left: 4px;
              font-weight: 600;
              color: #17e6a1;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .keepRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
        .totalData {
          //margin-top: 10px;
          margin-left: 32px;
          .totalDataTitle {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            margin-right: 4px;
          }
          .totalDataContent {
            font-size: 20px;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            color: #00c3ff;
          }
        }
      }
      .rightImg {
        width: 174px;
        height: 174px;
        background-image: url('../../../assets/dataWatchImg/dashboard_top_card_img_01.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .todayDataItem2 {
      display: flex;
      width: calc(25% - 24px);
      min-width: 450px;
      height: 174px;
      // margin-bottom: 24px;
      margin-right: 24px;
      // text-align: center;
      background-image: url('../../../assets/dataWatchImg/dashboard_top_card_bg_02.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .leftContent {
        z-index: 10;
        width: calc(100% - 174px);
        height: 174px;
        .leftTitle {
          width: 450px;
          height: 40px;
          background-image: url('../../../assets/dataWatchImg/en/dashboard_top_card_title_en_02.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .leftTodayData {
          margin-left: 34px;
          margin-bottom: -1px;
          font-size: 48px;
          font-family: Barlow-SemiBold, Barlow;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        .leftTodayDataRate {
          margin-left: 34px;
          color: rgba(255, 255, 255, 0.6);
          .leftTodayDataRateSplit {
            margin: 0 8px;
          }
          .leftTodayDataRateWeek {
            .upRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ff4d79;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .downRate {
              margin-left: 4px;
              font-weight: 600;
              color: #17e6a1;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .keepRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
        .totalData {
          //margin-top: 10px;
          margin-left: 32px;
          .totalDataTitle {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            margin-right: 4px;
          }
          .totalDataContent {
            font-size: 20px;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            color: #00d4ff;
          }
        }
      }
      .rightImg {
        width: 174px;
        height: 174px;
        background-image: url('../../../assets/dataWatchImg/dashboard_top_card_img_02.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .todayDataItem3 {
      display: flex;
      width: calc(25% - 24px);
      min-width: 450px;
      height: 174px;
      // margin-bottom: 24px;
      margin-right: 24px;
      // text-align: center;
      background-image: url('../../../assets/dataWatchImg/dashboard_top_card_bg_01.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .leftContent {
        z-index: 10;
        width: calc(100% - 174px);
        height: 174px;
        .leftTitle {
          width: 450px;
          height: 40px;
          background-image: url('../../../assets/dataWatchImg/en/dashboard_top_card_title_en_03.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .leftTodayData {
          margin-left: 34px;
          margin-bottom: -1px;
          font-size: 48px;
          font-family: Barlow-SemiBold, Barlow;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        .leftTodayDataRate {
          margin-left: 34px;
          color: rgba(255, 255, 255, 0.6);
          .leftTodayDataRateSplit {
            margin: 0 8px;
          }
          .leftTodayDataRateWeek {
            .upRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ff4d79;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .downRate {
              margin-left: 4px;
              font-weight: 600;
              color: #17e6a1;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .keepRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
        .totalData {
          //margin-top: 10px;
          margin-left: 32px;
          .totalDataTitle {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            margin-right: 4px;
          }
          .totalDataContent {
            font-size: 20px;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            color: #00c3ff;
          }
        }
      }
      .rightImg {
        width: 174px;
        height: 174px;
        background-image: url('../../../assets/dataWatchImg/dashboard_top_card_img_03.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .todayDataItem4 {
      display: flex;
      width: calc(25% - 24px);
      min-width: 450px;
      height: 174px;
      // margin-bottom: 24px;
      margin-right: 24px;
      // text-align: center;
      background-image: url('../../../assets/dataWatchImg/dashboard_top_card_bg_04.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .leftContent {
        z-index: 10;
        width: calc(100% - 174px);
        height: 174px;
        .leftTitle {
          width: 450px;
          height: 40px;
          background-image: url('../../../assets/dataWatchImg/en/dashboard_top_card_title_en_04.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .leftTodayData {
          margin-left: 34px;
          margin-bottom: -1px;
          font-size: 48px;
          font-family: Barlow-SemiBold, Barlow;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        .leftTodayDataRate {
          margin-left: 34px;
          color: rgba(255, 255, 255, 0.6);
          .leftTodayDataRateSplit {
            margin: 0 8px;
          }
          .leftTodayDataRateWeek {
            .upRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ff4d79;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .downRate {
              margin-left: 4px;
              font-weight: 600;
              color: #17e6a1;
              .img {
                width: 14px;
                height: 14px;
              }
            }
            .keepRate {
              margin-left: 4px;
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
        .totalData {
          //margin-top: 10px;
          margin-left: 32px;
          .totalDataTitle {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            margin-right: 4px;
          }
          .totalDataContent {
            font-size: 20px;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            color: #00d4ff;
          }
        }
      }
      .rightImg {
        width: 174px;
        height: 174px;
        background-image: url('../../../assets/dataWatchImg/dashboard_top_card_img_04.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .bottomDiv {
    margin: 0 24px 24px 24px;
    //width: calc(67% - 24px);
    //min-width: 1293px;
    display: flex;
    width: 100%;
    min-width: 1920px;
    .leftRecipe {
      width: calc(67vw - 24px);
      min-width: 1293px;
      margin-right: 24px;
      .leftRecipeTitle1 {
        width: 100%;
        height: 48px;
        background-image: url('../../../assets/dataWatchImg/dashboard_popular_cookbook_title_bg 2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .leftRecipeDiv {
        width: 100%;
        min-width: 1293px;
        min-height: 716px;
        padding: 16px;
        background-image: url('../../../assets/dataWatchImg/dashboard_popular_cookbook_title_bg.svg');
        background-repeat: no-repeat;
        background-size: 100%;
        .leftRecipeDownloadTitle {
          width: 400px;
          height: 28px;
          background-image: url('../../../assets/dataWatchImg/en/dashboard_popular_cookbook_title_en_s01.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          margin-bottom: 16px;
        }
        .recipeDownloadList {
          display: flex;
          justify-content: space-between;
          .recipeDownloadItemLeft {
            margin-right: 16px;
            flex: 1;
            color: #ffffff;
            .recipeDownloadItem0 {
              padding-right: 8px;
              margin-bottom: 2px;
              display: flex;
              height: 56px;
              width: 100%;
              align-items: center;
              background: linear-gradient(90deg, rgba(255, 213, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
              .indexDiv {
                width: 32px;
                height: 32px;
                font-size: 16px;
                font-family: Barlow-SemiBold, Barlow;
                font-weight: 600;
                color: #ffd500;
                line-height: 32px;
                text-align: center;
                background: rgba(255, 213, 0, 0.2);
                box-shadow: inset 0px 0px 8px 0px #ffd500;
                margin-right: 8px;
              }
              .barDiv {
                width: 100%;
                flex: 1;
                .itemDesc {
                  display: flex;
                  justify-content: space-between;
                  .itemDescName {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  }
                  .itemDescValue {
                    font-size: 20px;
                    font-family: Barlow-SemiBold, Barlow;
                    font-weight: 600;
                    color: #ffd500;
                    line-height: 28px;
                  }
                }
                /deep/ .progressDiv {
                  .el-progress-bar {
                    width: 100%;
                    .el-progress-bar__outer {
                      height: 10px !important;
                      background-color: rgba(204, 216, 255, 0.2);
                      .el-progress-bar__inner {
                        background-image: linear-gradient(
                          270deg,
                          #ffd500 0%,
                          rgba(0, 0, 0, 0) 100%
                        );
                        background-color: rgba(204, 216, 255, 0.2);
                        border-radius: 0;
                        border-right: 4px solid #ffffff;
                        box-shadow: 0px 0px 4px 0px #ffffff;
                      }
                    }
                  }
                }
              }
            }
            .recipeDownloadItem1 {
              margin-bottom: 2px;
              padding-right: 8px;
              display: flex;
              height: 56px;
              width: 100%;
              align-items: center;
              background: linear-gradient(
                90deg,
                rgba(204, 221, 255, 0.4) 0%,
                rgba(0, 0, 0, 0) 100%
              );
              .indexDiv {
                width: 32px;
                height: 32px;
                font-size: 16px;
                font-family: Barlow-SemiBold, Barlow;
                font-weight: 600;
                color: #ccddff;
                line-height: 32px;
                text-align: center;
                background: rgba(205, 222, 255, 0.2);
                box-shadow: inset 0px 0px 8px 0px #ccddff;
                margin-right: 8px;
              }
              .barDiv {
                width: 100%;
                flex: 1;
                .itemDesc {
                  display: flex;
                  justify-content: space-between;
                  .itemDescName {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  }
                  .itemDescValue {
                    font-size: 20px;
                    font-family: Barlow-SemiBold, Barlow;
                    font-weight: 600;
                    color: #ccddff;
                    line-height: 28px;
                  }
                }
                /deep/ .progressDiv {
                  .el-progress-bar {
                    width: 100%;
                    .el-progress-bar__outer {
                      height: 10px !important;
                      background-color: rgba(204, 216, 255, 0.2);
                      .el-progress-bar__inner {
                        background-image: linear-gradient(
                          270deg,
                          #ccddff 0%,
                          rgba(0, 0, 0, 0) 100%
                        );
                        background-color: rgba(204, 216, 255, 0.2);
                        border-radius: 0;
                        border-right: 4px solid #ffffff;
                        box-shadow: 0px 0px 4px 0px #ffffff;
                      }
                    }
                  }
                }
              }
            }
            .recipeDownloadItem2 {
              margin-bottom: 2px;
              padding-right: 8px;
              display: flex;
              height: 56px;
              width: 100%;
              align-items: center;
              background: linear-gradient(90deg, rgba(230, 115, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
              .indexDiv {
                width: 32px;
                height: 32px;
                font-size: 16px;
                font-family: Barlow-SemiBold, Barlow;
                font-weight: 600;
                color: #e67300;
                line-height: 32px;
                text-align: center;
                background: rgba(204, 123, 41, 0.2);
                box-shadow: inset 0px 0px 8px 0px #e68a2e;
                margin-right: 8px;
              }
              .barDiv {
                width: 100%;
                flex: 1;
                .itemDesc {
                  display: flex;
                  justify-content: space-between;
                  .itemDescName {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  }
                  .itemDescValue {
                    font-size: 20px;
                    font-family: Barlow-SemiBold, Barlow;
                    font-weight: 600;
                    color: #e67300;
                    line-height: 28px;
                  }
                }
                /deep/ .progressDiv {
                  .el-progress-bar {
                    width: 100%;
                    .el-progress-bar__outer {
                      height: 10px !important;
                      background-color: rgba(204, 216, 255, 0.2);
                      .el-progress-bar__inner {
                        background-image: linear-gradient(
                          270deg,
                          #e67300 0%,
                          rgba(0, 0, 0, 0) 100%
                        );
                        background-color: rgba(204, 216, 255, 0.2);
                        border-radius: 0;
                        border-right: 4px solid #ffffff;
                        box-shadow: 0px 0px 4px 0px #ffffff;
                      }
                    }
                  }
                }
              }
            }
            .recipeDownloadItem {
              margin-bottom: 2px;
              padding-right: 8px;
              display: flex;
              height: 56px;
              width: 100%;
              align-items: center;
              background: linear-gradient(90deg, rgba(51, 99, 255, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
              .indexDiv {
                width: 32px;
                height: 32px;
                font-size: 16px;
                font-family: Barlow-SemiBold, Barlow;
                font-weight: 600;
                color: #99b1ff;
                line-height: 32px;
                text-align: center;
                background: rgba(102, 138, 255, 0.2);
                box-shadow: inset 0px 0px 8px 0px #668aff;
                margin-right: 8px;
              }
              .barDiv {
                width: 100%;
                flex: 1;
                .itemDesc {
                  display: flex;
                  justify-content: space-between;
                  .itemDescName {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  }
                  .itemDescValue {
                    font-size: 20px;
                    font-family: Barlow-SemiBold, Barlow;
                    font-weight: 600;
                    color: #00c3ff;
                    line-height: 28px;
                  }
                }
                /deep/ .progressDiv {
                  .el-progress-bar {
                    width: 100%;
                    .el-progress-bar__outer {
                      height: 10px !important;
                      background-color: rgba(204, 216, 255, 0.2);
                      .el-progress-bar__inner {
                        background-image: linear-gradient(
                          270deg,
                          #668aff 0%,
                          rgba(0, 0, 0, 0) 100%
                        );
                        background-color: rgba(204, 216, 255, 0.2);
                        border-radius: 0;
                        border-right: 4px solid #ffffff;
                        box-shadow: 0px 0px 4px 0px #ffffff;
                      }
                    }
                  }
                }
              }
            }
          }
          .recipeDownloadItemRight {
            //margin-right: 16px;
            flex: 1;
            color: #ffffff;
            .recipeDownloadItem {
              padding-right: 8px;
              margin-bottom: 2px;
              display: flex;
              height: 56px;
              width: 100%;
              align-items: center;
              background: linear-gradient(90deg, rgba(51, 99, 255, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
              .indexDiv {
                width: 32px;
                height: 32px;
                font-size: 16px;
                font-family: Barlow-SemiBold, Barlow;
                font-weight: 600;
                color: #99b1ff;
                line-height: 32px;
                text-align: center;
                background: rgba(102, 138, 255, 0.2);
                box-shadow: inset 0px 0px 8px 0px #668aff;
                margin-right: 8px;
              }
              .barDiv {
                width: 100%;
                flex: 1;
                .itemDesc {
                  display: flex;
                  justify-content: space-between;
                  .itemDescName {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  }
                  .itemDescValue {
                    font-size: 20px;
                    font-family: Barlow-SemiBold, Barlow;
                    font-weight: 600;
                    color: #00c3ff;
                    line-height: 28px;
                  }
                }
                /deep/ .progressDiv {
                  .el-progress-bar {
                    width: 100%;
                    .el-progress-bar__outer {
                      height: 10px !important;
                      background-color: rgba(204, 216, 255, 0.2);
                      .el-progress-bar__inner {
                        background-image: linear-gradient(
                          270deg,
                          #668aff 0%,
                          rgba(0, 0, 0, 0) 100%
                        );
                        background-color: rgba(204, 216, 255, 0.2);
                        border-radius: 0;
                        border-right: 4px solid #ffffff;
                        box-shadow: 0px 0px 4px 0px #ffffff;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .leftRecipeBottom {
        margin-top: 32px;
        width: 100%;
        min-width: 1293px;
        min-height: 334px;
        display: flex;
        justify-content: space-between;
        .downLoadType {
          color: #f0f4fc;
          width: calc(50% - 24px);
          .leftRecipeTypeDownloadTitle {
            width: 400px;
            height: 28px;
            background-image: url('../../../assets/dataWatchImg/en/dashboard_popular_cookbook_title_en_s02.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-bottom: 16px;
          }
          .leftRecipeTypeDownloadImg {
            width: 622px;
            height: 300px;
            padding: 8px;
            background-image: url('../../../assets/dataWatchImg/dashboard_popular_cookbook_title_s02_bg.png');
            background-repeat: no-repeat;
            background-size: 50% 100%;
          }
        }
        .searchKeyDiv {
          color: #f0f4fc;
          width: calc(50% - 24px);
          margin-right: 24px;
          .leftRecipeTypeDownloadTitle {
            width: 400px;
            height: 28px;
            background-image: url('../../../assets/dataWatchImg/en/dashboard_popular_cookbook_title_en_s03.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-bottom: 16px;
          }
          .searchKeyContent {
            width: 548px;
            height: 274px;
            padding: 8px;
          }
        }
      }
    }
    .rightRecipe {
      width: calc(33% - 84px);
      min-width: 555px;
      margin-right: 24px;
      .rightRecipeTitle1 {
        width: 100%;
        height: 34px;
        background-image: url('../../../assets/dataWatchImg/dashboard_popular_model_title_bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .rightRecipeHeatModel {
        height: 210px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(51, 99, 255, 0.4) 100%);
        width: 100%;
        padding: 16px;

        .rightRecipeHeatModelRowTitle {
          font-weight: 600;
          color: #526ecc;
          margin-bottom: 4px;
        }
        .rightRecipeHeatModelRow0 {
          color: #ffd500;
          line-height: 30px;
          margin-bottom: 4px;
          .indexCol {
            margin-right: 4px;
            width: 30px;
            height: 30px;
            background: rgba(255, 213, 0, 0.2);
            box-shadow: inset 0px 0px 6px 0px #ffd500;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            text-align: center;
          }
          .rightRecipeHeatModelIndexOther {
            width: 100%;
            padding-left: 8px;
            height: 30px;
            display: flex;
            background: rgba(255, 213, 0, 0.2);
            box-shadow: inset 0px 0px 6px 0px #ffd500;
            .upRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ff4d79;
            }
            .keepRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ffffff;
            }
            .downRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #17e6a1;
            }
          }
        }
        .rightRecipeHeatModelRow1 {
          color: #ccddff;
          line-height: 30px;
          margin-bottom: 4px;
          .indexCol {
            margin-right: 4px;
            width: 30px;
            height: 30px;
            background: rgba(205, 222, 255, 0.2);
            box-shadow: inset 0px 0px 6px 0px #ccddff;
            font-weight: 600;
            text-align: center;
          }
          .rightRecipeHeatModelIndexOther {
            width: 100%;
            padding-left: 8px;
            height: 30px;
            display: flex;
            background: rgba(205, 222, 255, 0.2);
            box-shadow: inset 0px 0px 6px 0px #ccddff;
            .upRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ff4d79;
            }
            .keepRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ffffff;
            }
            .downRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #17e6a1;
            }
          }
        }
        .rightRecipeHeatModelRow2 {
          color: #e67400;
          line-height: 30px;
          margin-bottom: 4px;
          .indexCol {
            margin-right: 4px;
            width: 30px;
            height: 30px;
            background: rgba(204, 123, 41, 0.2);
            box-shadow: inset 0px 0px 6px 0px #e68a2e;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            text-align: center;
          }
          .rightRecipeHeatModelIndexOther {
            width: 100%;
            padding-left: 8px;
            height: 30px;
            display: flex;
            background: rgba(204, 123, 41, 0.2);
            box-shadow: inset 0px 0px 6px 0px #e68a2e;
            .upRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ff4d79;
            }
            .keepRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ffffff;
            }
            .downRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #17e6a1;
            }
          }
        }
        .rightRecipeHeatModelRow {
          color: #ffffff;
          line-height: 30px;
          margin-bottom: 4px;
          .indexCol {
            margin-right: 4px;
            width: 30px;
            height: 30px;
            //background: rgba(255,213,0,0.2);
            //box-shadow: inset 0px 0px 6px 0px #FFD500;
            font-family: Barlow-SemiBold, Barlow;
            font-weight: 600;
            text-align: center;
          }
          .rightRecipeHeatModelIndexOther {
            width: 100%;
            padding-left: 8px;
            height: 30px;
            display: flex;
            //background: rgba(255,213,0,0.2);
            //box-shadow: inset 0px 0px 6px 0px #FFD500;
            .upRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ff4d79;
            }
            .keepRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #ffffff;
            }
            .downRate {
              font-family: Barlow-SemiBold, Barlow;
              font-weight: 600;
              color: #17e6a1;
            }
          }
        }
      }
      .rightLastPublishRecipe {
        height: 210px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(51, 99, 255, 0.4) 100%);
        width: 100%;
        padding: 16px;

        .rightRecipeHeatModelRowTitle {
          font-weight: 600;
          color: #526ecc;
          margin-bottom: 4px;
        }
        .rightLastPublishRecipeRow1 {
          background: rgba(102, 138, 255, 0);
          color: #ffffff;
          height: 30px;
          line-height: 30px;
        }
        .rightLastPublishRecipeRow0 {
          background: rgba(102, 138, 255, 0.2);
          color: #ffffff;
          height: 30px;
          line-height: 30px;
        }
      }
      .rightRecipeTitleFault {
        width: 100%;
        height: 34px;
        background-image: url('../../../assets/dataWatchImg/dashboard_fault_title_bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .rightRecipeFault {
        height: 210px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(153, 31, 51, 0.4) 100%);
        width: 100%;
        padding: 16px;
        .rightRecipeFaultRowTitle {
          font-weight: 600;
          color: #cc5266;
          margin-bottom: 4px;
        }
        .rightRecipeFaultRow1 {
          background: rgba(102, 138, 255, 0);
          color: #ffffff;
          height: 30px;
          line-height: 30px;
        }
        .rightRecipeFaultRow0 {
          background: rgba(255, 102, 128, 0.2);
          color: #ffffff;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
